// components/slides/SlidesDashboardToggle.tsx
'use client';

import { useCallback } from 'react';
import { useKernel } from '@/kernel/Kernel';
import { SegmentSwitch } from '@/components/ui/SegmentSwitch';
import { useSlidesStore } from './slidesStore';
import { useKernelStore } from '@/kernel/kernelStores';
import { canAccessSlidesTraining } from '#lib/access/slidesAccess';

// The same switch Source and List use: decks on the left, training on the right.
const VIEWS = [
  { key: 'decks', label: 'Dashboard' },
  { key: 'training', label: 'Training' },
] as const;

export function SlidesDashboardToggle() {
  const { kernel } = useKernel();
  const view = useSlidesStore(s => s.dashboardView);
  const canTrain = useKernelStore(s => canAccessSlidesTraining(s.userContext));
  const switchView = useCallback((next: (typeof VIEWS)[number]['key']) => {
    useSlidesStore.getState().setDashboardView(next);
    kernel.current?.logUserAction(next === 'training' ? 'Training opened from Slides dashboard' : 'Slides dashboard opened from Training', { view: next });
  }, [kernel]);
  // Training is for the review experts only: everyone else sees no switch at all.
  if (!canTrain) return null;
  return <SegmentSwitch groupLabel="Slides view" options={VIEWS} value={view} onChange={switchView} />;
}
